import inView from './includes/inview';
export default {
    init() {

        this.nextSlide = 1
        this.totalSlides = 0

        $('.btn--history').click( (e) => {
            e.preventDefault()
            $('.history-intro').fadeOut()
            this.initSlider()
        })

        this.initSlider()

    },
    initSlider() {

        const self = this

        this.time = 2
        this.bar = $('.slider-history-progress__bar')
        this.mainSlider = $('.slider-history')
        this.navSlider = $('.slider-history-nav')
        this.mainBg = $('.history-content__bg')
        this.isPause = true
        this.tick = 0
        this.percentTime = 0

        this.mainSlider.on('init', (event, slick) => {
            this.totalSlides = slick.slideCount
        })

        this.mainSlider.slick({
            autoplay: false,
            arrows: false,
            rows: 0,
            infinite: false,
            pauseOnFocus: true,
            pauseOnHover: true,
            fade: true,
            arrows: true,
            asNavFor: '.slider-history-nav',
            prevArrow:'<button type="button" class="slick-arrow slick-arrow--prev"><i class="far fa-lg fa-long-arrow-alt-left"></i></button>',
            nextArrow:'<button type="button" class="slick-arrow slick-arrow--next"><i class="far fa-lg fa-long-arrow-alt-right"></i></button>',
        })

        this.navSlider.slick({
            autoplay: false,
            arrows: true,
            rows: 0,
            vertical: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: false,
            asNavFor: '.slider-history',
            focusOnSelect: true,
            prevArrow:'<button type="button" class="slick-arrow slick-arrow--prev"><i class="fal fa-2x fa-angle-up"></i></button>',
            nextArrow:'<button type="button" class="slick-arrow slick-arrow--next"><i class="fal fa-2x fa-angle-down"></i></button>',
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                    },
                },
            ],
        })

        $('.slider-history, .slider-history-nav').on({
            mouseenter: function() {
                self.isPause = true;
            },
            mouseleave: function() {
                self.isPause = true;
            }
        })

        this.mainSlider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            this.nextSlide = nextSlide
            if (this.nextSlide < (this.totalSlides - 1)) {
                this.isPause = true
                this.progressStart()
                this.mainBg.fadeOut( 500, () => {
                    this.mainBg.css('background-image', 'url(' + $('.slider-history .slick-slide.slick-current').attr('data-bg') + ')')
                    this.mainBg.fadeIn(500)
                })
            } else {
                this.progressReset()
                this.percentTime = 0
                this.tick = 0
                this.isPause = true
            }
        })

        this.progressStart()

    },
    progressStart() {

        this.progressReset()
        this.percentTime = 0
        this.isPause = true

        this.tick = setInterval(() => {
            this.progressInterval()
        }, 20)

    },
    progressInterval() {
        if (!this.isPause) {
            this.percentTime += 1 / (this.time + 0.1)

            this.bar.css({
                width: this.percentTime + '%'
            })

            if(this.percentTime >= 100) {
                this.mainSlider.slick('slickNext')
            }
        }

    },
    progressReset() {
        this.bar.css({
            width: 0 + '%'
        })

        clearInterval(this.tick)
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/history.js